import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { queryKeys } from "../queryKeys";
import { apiUrls } from "src/consts/ApiUrls";
import { portalApiClient } from "../apiClient";
import useServiceStatus from "./useServiceStatus";
import { objectTypes } from "src/consts/objectTypes";

export default function useInspectionItems(id: string | undefined) {
  const params = useParams();
  const { inspectionId, variationId, companyId } = params;
  const { data: serviceStatus } = useServiceStatus();
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: [
      ...queryKeys.deviationsByInspectionId(companyId, id ?? inspectionId),
      serviceStatus?.Deviation?.updatedAt,
    ],
    queryFn: async () => {
      return await portalApiClient
        .get(
          apiUrls.getDeviationsByInspectionId.url(
            id ?? inspectionId ?? variationId
          )
        )
        .then((response) => response.data)
        .catch((e) => []);
    },
  });
  return {
    ...query,
    data: query.data?.filter(
      (item) =>
        item.objectType === objectTypes.InspectionItem &&
        item.parentDeviationId === Number(id ?? inspectionId)
    ),
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.deviationsByInspectionId(
          companyId,
          id ?? inspectionId
        ),
      }),
    enabled: id !== undefined || inspectionId !== undefined,
  };
}
